<script>
import Modal from "./components/Modal.svelte"
import Home from "./components/Home.svelte"
import About from "./components/About.svelte"
import Dignitaries from "./components/Dignitaries.svelte"
import Advisory from "./components/Advisory.svelte"
import Speakers from "./components/Speakers.svelte"
import Publications from "./components/Publications.svelte"
import Register from "./components/Register.svelte"
import Topics from "./components/Topics.svelte"
import Venue from "./components/Venue.svelte"
import Sponsors from "./components/Sponsors.svelte"
</script>
<main>
	<div class="container-fluid">
		<Home/>
		<About/>
		<Dignitaries/>
		<Advisory/>
		<Speakers/>
		<Publications/>
		<Register/>
		<Topics/>
		<Venue/>
		<Sponsors/>

	    <footer>
	      <span class="copyright">Copyright &copy; 2021 NIT Trichy. All Rights Reserved.</span>
	    </footer>
		<Modal/>

	</div>
</main>
